"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILSpinner = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var ILSpinner = function (props) {
    return (react_1.default.createElement(material_1.Box, { display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%' },
        react_1.default.createElement(CircularProgress_1.default, __assign({ 'aria-label': 'aria-progressbar-name' }, props))));
};
exports.ILSpinner = ILSpinner;
